export const cart = {
  GET_ITEMS_LOADING: "cart/get/loading",
  GET_ITEMS_SUCCESS: "cart/get/success",
  GET_ITEMS_ERROR: "cart/get/error",
  UPDATE_COUNT_LOADING: "cart/update/loading",
  UPDATE_COUNT_SUCCESS: "cart/update/success",
  UPDATE_COUNT_ERROR: "cart/update/error",
  DELETE_ITEM_LOADING: "cart/delete/loading",
  DELETE_ITEM_SUCCESS: "cart/delete/success",
  DELETE_ITEM_ERROR: "cart/delete/error",
  ADD_ITEM_LOADING: "cart/add/loading",
  ADD_ITEM_SUCCESS: "cart/add/success",
  ADD_ITEM_ERROR: "cart/add/error",
  RESET: "cart/reset/items",
};
